import Header from "../components/Header";
import { useState, useEffect } from "react";
import api from "../components/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Modal, Button, Spinner } from "react-bootstrap";

const PendingOrders = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [pendingOrders, setPendingOrders] = useState([]);
  const [loading, setLoading] = useState(true); // Ajout de l'état pour le chargement
  const [loading1, setLoading1] = useState(false); // Ajout de l'état pour le chargement
  const [showValidatedModal, setShowValidatedModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [actionType, setActionType] = useState("");

  useEffect(() => {
    api
      .get("/pending_orders")
      .then((response) => {
        setPendingOrders(response.data.pendingOrders);
        console.log("Contenu : ", response.data.pendingOrders);
      })
      .catch((error) => {
        console.error("Erreur de récupération : ", error);
      })
      .finally(() => setLoading(false)); // On met à jour le chargement à false une fois les données récupérées
  }, []);

  const orderInProgress = () => {
    setLoading1(true);
    if (!selectedOrder) return;
    api
      .get(`/order_in_progress/${selectedOrder.id}`)
      .then((response) => {
        setLoading1(false);
        console.log("Commande En Cours : ", response.data);
        handleCloseValidatedModal();
        alert("Commande Validée");
      })
      .catch((error) => {
        console.error("Erreur de récupération : ", error);
      });
  };

  const orderCancelled = () => {
    setLoading1(true);
    if (!selectedOrder) return;
    api
      .get(`/order_cancelled/${selectedOrder.id}`)
      .then((response) => {
        setLoading1(false);
        console.log(response.data);
        handleCloseValidatedModal();
        alert("Commande Annulée");
      })
      .catch((error) => {
        console.error("Erreur d'annulation : ", error);
      });
  };

  const handleShowValidatedModal = (pendingOrder, action) => {
    setShowValidatedModal(true);
    setSelectedOrder(pendingOrder);
    setActionType(action);
  };

  const handleCloseValidatedModal = () => {
    setShowValidatedModal(false);
    setSelectedOrder(null);
  };

  return (
    <>
      <Header />

      <div className="container mt-5">
        <h1 className="text-center fw-bold mb-4">Commandes En Attente</h1>

        {/* Loader principal */}
        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3 text-muted">Chargement des commandes...</p>
          </div>
        ) : (
          <div className="card border-0 shadow-sm rounded-3">
            <div className="table-responsive" style={{ maxHeight: "500px" }}>
              <table className="table table-hover align-middle mb-0">
                <thead className="table-primary text-nowrap">
                  <tr>
                    <th>#</th>
                    <th>Client</th>
                    <th>Menu</th>
                    <th>Description</th>
                    <th>Date</th>
                    <th>Qté</th>
                    <th>Prix Total</th>
                    <th>Notes</th>
                    <th>Localisation</th>
                    <th>Statut</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* On filtre les commandes valides avant de mapper */}
                  {pendingOrders.filter((o) => o.status === "En attente")
                    .length === 0 ? (
                    <tr>
                      <td
                        colSpan="11"
                        className="text-center py-4 text-muted italic"
                      >
                        <div className="py-3">
                          <p className="m-0">
                            Aucune commande en attente pour le moment.
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    pendingOrders
                      .filter((order) => order.status === "En attente")
                      .map(
                        (order, index) =>
                          // On itère sur les items de chaque commande
                          order.order_items &&
                          order.order_items.map((item, itemIndex) => (
                            <tr key={`${order.id}-${item.id}-${itemIndex}`}>
                              <td className="fw-bold text-muted">
                                {index + 1}
                              </td>
                              <td className="fw-semibold">
                                {order.user?.name || "Inconnu"}
                              </td>
                              <td>{item.menu_item?.name || "Plat supprimé"}</td>
                              <td
                                className="small text-muted"
                                style={{ maxWidth: "200px" }}
                              >
                                {item.menu_item?.description || "-"}
                              </td>
                              <td className="small">
                                {item.created_at
                                  ? new Date(item.created_at).toLocaleString(
                                      "fr-FR",
                                      {
                                        day: "numeric",
                                        month: "short",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      },
                                    )
                                  : "N/A"}
                              </td>
                              <td className="text-center">{item.quantity}</td>
                              <td className="fw-bold text-primary">
                                {order.total_price} CFA
                              </td>
                              <td
                                className="small text-truncate"
                                style={{ maxWidth: "150px" }}
                              >
                                {order.notes || "-"}
                              </td>
                              <td>
                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle">
                                  {order.localisation}
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-warning text-dark">
                                  {order.status}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex gap-2 justify-content-center">
                                  <button
                                    className="btn btn-sm btn-success shadow-sm"
                                    onClick={() =>
                                      handleShowValidatedModal(order, "confirm")
                                    }
                                  >
                                    <FontAwesomeIcon icon={faCheck} />
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() =>
                                      handleShowValidatedModal(order, "cancel")
                                    }
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )),
                      )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Modal de Confirmation */}
      <Modal
        show={showValidatedModal}
        onHide={handleCloseValidatedModal}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">
            {actionType === "confirm"
              ? "✅ Confirmer la commande"
              : "❌ Annuler la commande"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {actionType === "confirm"
            ? "Voulez-vous passer cette commande en préparation ?"
            : "Voulez-vous vraiment rejeter cette commande ?"}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" onClick={handleCloseValidatedModal}>
            Retour
          </Button>
          <Button
            variant={actionType === "confirm" ? "success" : "danger"}
            disabled={loading1}
            onClick={
              actionType === "confirm" ? orderInProgress : orderCancelled
            }
          >
            {loading1 ? (
              <>
                <Spinner size="sm" className="me-2" /> Traitement...
              </>
            ) : actionType === "confirm" ? (
              "Confirmer"
            ) : (
              "Annuler la commande"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PendingOrders;
